import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ToastType } from '@app/enums/toast-type.enum';
import { DataTestIdPipe } from '@app/pipes/data-test-id/data-test-id-pipe';
import { ToastService } from '@app/services/toast/toast.service';

@Component({
    selector: 'app-toast',
    imports: [CommonModule, MatIconModule, DataTestIdPipe],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
})
export class ToastComponent {
    private readonly toastService: ToastService = inject(ToastService);

    readonly toasts = computed(() => this.toastService.toasts());

    readonly toastTypes: Record<ToastType, string> = {
        [ToastType.Success]: 'check_circle',
        [ToastType.Warning]: 'warning',
        [ToastType.Info]: 'info',
        [ToastType.Error]: 'report',
        [ToastType.None]: 'none',
    };

    dismissToast(id: number): void {
        this.toastService.removeToast(id);
    }

    getToastIcon(type: ToastType) {
        return this.toastTypes[type];
    }

    getToastIconClasses(type: ToastType) {
        return {
            'rcp-text-border-toast-success': type === ToastType.Success,
            'rcp-text-border-toast-warning': type === ToastType.Warning,
            'rcp-text-border-toast-info': type === ToastType.Info,
            'rcp-text-border-toast-error': type === ToastType.Error,
        };
    }

    getToastContainerClasses(type: ToastType) {
        return {
            'rcp-flex rcp-w-[312px] rcp-text-white rcp-flex-row rcp-items-start rcp-border-l-[4px] rcp-text-[14px] rcp-leading-[20px] rcp-tracking-[0.1px] rcp-text-text-high-contrast':
                true,
            'rcp-border-border-toast-success rcp-bg-bg-toast-success':
                type === ToastType.Success,
            'rcp-border-border-toast-warning rcp-bg-bg-toast-warning':
                type === ToastType.Warning,
            'rcp-border-border-toast-info rcp-bg-bg-toast-info': type === ToastType.Info,
            'rcp-border-border-toast-error rcp-bg-bg-toast-error':
                type === ToastType.Error,
        };
    }
}
